module.exports = __webpack_public_path__ + "media/application/images/svgs/refresh-ccw-4cbd1f04c1bc45b0b2e116e121d3dcf6.svg";